import Immutable from 'immutable';

export default Immutable.Record({
  songs: Immutable.List(),
  drops: Immutable.List(),
  title: undefined,
  key: undefined,
  isEmpty: function isEmpty() {
    return !this.title && this.songs.size < 1;
  }
});


/** WEBPACK FOOTER **
 ** ./src/models/AudioPlaylist.es6
 **/